// React
import { motion } from "framer-motion";

// Components
import Hero from "../components/layout/Hero";

// Assets
import "../assets/styles/companyInfo.css";
import heroImg from "../assets/images/imprint/hero.jpg";

// Hooks
import { useTranslation } from "../hooks/useTranslation";

export default function CompanyInfo() {
    const t = useTranslation();

    return (
        <section id="companyInfoSection">
            <Hero title={t("company.title")} bgImage={heroImg} />
            <div className="container py-5">
                <motion.div className="company-info-box"
                    whileHover={{ scale: 1.01 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                    <div className="">
                        <h2 className="company-info-section-title">
                            {t("company.sectionTitle")}
                        </h2>

                        <h3 className="company-info-title">{t("company.businessTitle")}</h3>
                        <ul className="company-info-list">
                            <li><strong>{t("company.businessName")}:</strong> Fehér Roland Balázs e.v.</li>
                            <li><strong>{t("company.address")}:</strong> 8000 Székesfehérvár, Budai út 154.</li>
                            <li><strong>{t("company.taxNumber")}:</strong> 55970051-2-27</li>
                            <li><strong>{t("company.regNumber")}:</strong> 54718515</li>
                            <li><strong>{t("company.phone")}:</strong> +36 30 491 9340</li>
                            <li><strong>{t("company.email")}:</strong> roygym2024@gmail.com</li>
                            <li><strong>{t("company.bankAccount")}:</strong> 10404883-50526969-80661016</li>
                        </ul>

                        <h3 className="company-info-title with-divider">{t("company.hostingTitle")}</h3>
                        <ul className="company-info-list">
                            <li><strong>{t("company.hostingName")}:</strong> Netlify, Inc.</li>
                            <li><strong>{t("company.hostingAddress")}:</strong> 44 Montgomery St Suite 300, San Francisco, California 94104, US</li>
                        </ul>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
